import { useMutation } from "react-query";
import { updateDVRType } from "../../../../../actions/Utilities/DVRType";
import { toast } from "components/toastNotification";
import { IDVRType } from "../types";
import { dvrTypeReFetching, editStateDVRType } from "../atoms/atoms";
import { useRecoilState, useSetRecoilState } from "recoil";

const useEditDVRType = () => {
  const setActionEditState = useSetRecoilState(editStateDVRType);
  const [isReFetching, setIsReFetching] = useRecoilState(dvrTypeReFetching);
  const { mutate } = useMutation((Data: IDVRType) => updateDVRType(Data), {
    onSuccess: (res) => {
      if (typeof res == "object") {
        toast.fire("Updating DVR Type failed", `${res.Message}`, "error");
      } else {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "DVR Type Updated Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `DVR Type Updated Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Updating DVR Type failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Updating DVR Type failed ",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire("Updating DVR Type failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Updating DVR Type failed", `${res}`, "error");
        }
      }
      // Redirect to View
      setActionEditState(false);

      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },
    onError: (error: any) => {
      toast.fire("Update DVR Type failed", `Error: ${error}`, "error");
    },
  });
  return mutate;
};

export default useEditDVRType;
